"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var asset_accessor_1 = require("./asset-accessor");

var NullImageAccessor =
/** @class */
function () {
  function NullImageAccessor() {}

  NullImageAccessor.prototype.asset = function () {
    return new asset_accessor_1.NullAssetAccessor();
  };

  NullImageAccessor.prototype.metadata = function () {
    return {};
  };

  NullImageAccessor.prototype.fluid = function (opts) {
    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  return NullImageAccessor;
}();

exports.NullImageAccessor = NullImageAccessor;